import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui';
import { Keyboard } from 'lucide-react';

interface ShortcutItem {
    keys: string[];
    description: string;
}

interface ShortcutsHelpModalProps {
    isOpen: boolean;
    onClose: () => void;
    shortcuts: ShortcutItem[];
}

export const ShortcutsHelpModal: React.FC<ShortcutsHelpModalProps> = ({ isOpen, onClose, shortcuts }) => {
    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-md bg-white z-[999]">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2">
                        <Keyboard className="h-5 w-5" />
                        Keyboard Shortcuts
                    </DialogTitle>
                    <DialogDescription>
                        Boost your productivity with these global shortcuts.
                    </DialogDescription>
                </DialogHeader>
                <div className="grid gap-4 py-4">
                    {shortcuts.map((shortcut, index) => (
                        <div key={index} className="flex items-center justify-between">
                            <span className="text-sm font-medium text-gray-500">{shortcut.description}</span>
                            <div className="flex gap-1">
                                {shortcut.keys.map((key, kIndex) => (
                                    <kbd
                                        key={kIndex}
                                        className="pointer-events-none inline-flex h-6 select-none items-center gap-1 rounded border bg-muted px-2.5 font-mono text-[10px] font-medium text-muted-foreground opacity-100 border-gray-200 bg-gray-100 text-gray-800"
                                    >
                                        {key}
                                    </kbd>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </DialogContent>
        </Dialog>
    );
};
